import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { LayoutType } from '../types/layouts.esm.js';

function removeLayout(layouts, id) {
  var result = layouts.filter(function (l) {
    return l.id !== id || l.type === LayoutType.Default || l.type === LayoutType.Predefined;
  }).filter(function (l) {
    return l.selected || l.type !== LayoutType.Custom;
  });
  var oneLayoutIsSelected = result.some(function (l) {
    return l.selected;
  });
  if (!oneLayoutIsSelected) {
    result = result.map(function (l) {
      return l.type === LayoutType.Default ? _objectSpread2(_objectSpread2({}, l), {}, {
        selected: true
      }) : l;
    });
  }
  return result;
}

export { removeLayout };
//# sourceMappingURL=remove-layout.esm.js.map
